if ($(".child-table").length > 0) { // only for this component
    // on row click
    $(".child-table div.row").on('click', function (e) {
        if ($(this).find("div.form-check.radio input").prop("disabled")) {
            return false;
        }

        var id = $(this).find("div.form-check.radio input");
        if (id.length == 0) {
            return;
        }
        var dataId = $(this).data('id');
        $("div.form-check.radio input").each(function (i, e) {
            if ($(e).attr('id') != id) {
                $(e).attr('checked', false).prop('checked', false);
                $("#value-" + $(e).data('id')).val('False');
            } 
        });
        $("#value-" + dataId).val('True');
        $("#radio-" + dataId).prop('checked', true).trigger("change");
    });

    $("div.form-check.radio input").on('click', function (e) {
        var id = $(this).attr('id');
        var dataId = $(this).data('id');
        $("div.form-check.radio input").each(function (i, e) {
            if ($(e).attr('id') != id) {
                $(e).attr('checked', false).prop('checked', false);
                $("#value-" + $(e).data('id')).val('False');
            }
        });
        $("#value-" + dataId).val('True');
    });

    $("div.form-check.checkbox input").on('click', function () {
        var id = $(this).attr('id');
        var dataId = $(this).data('id');
        if ($(this).is(':checked')) {
            $("#value-" + dataId).val('True');
        } else {
            $("#value-" + dataId).val('False');
        }
    });
}